import { getLeaderboardTimeframe } from "@/sales-tools/leaderboard/api/getLeaderboardTimeframe";
import { getGamificationApiClient } from "../../home-product/api/api";

export const getTotalCallCount = async (): Promise<number> => {
    const { start, end } = getLeaderboardTimeframe();

    return await getGamificationApiClient()
        .get(`v1/metrics/calls?start=${start}&end=${end}`, { retry: 0 })
        .json<number>();
};
